import { pathgen } from 'object-path-generator';
import { useStoreActions } from '~/store/store-context';
import { useMutationState } from '../useMutationState';
export const useDraftProposalTestIds = pathgen('useDraftProposalTestIds');
export const useDraftProposal = function useDraftProposal() {
    let { onSuccess, withPageLoader = true, biCode } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { mutate, isLoading } = useMutationState({
        mutationFn: async (param)=>{
            let { draftId, relationshipId } = param;
            const newDraftId = await api.draft.duplicate(draftId);
            await api.relationship.cancelProposal(relationshipId);
            return newDraftId;
        },
        onSuccess,
        withPageLoader,
        biCode,
        toasts: {
            successMessage: 'Proposal moved to drafts successfully',
            successTestId: useDraftProposalTestIds.SuccessToast(),
            errorMessage: 'Failed to move proposal to drafts',
            errorTestId: useDraftProposalTestIds.ErrorToast()
        }
    });
    return {
        draftProposal: mutate,
        isLoading
    };
};
